import { IsEnglish } from './language';
import * as storage from './storage';

export function home() {
    window.location.href = './';
}

export function login() {
    window.location.href = 'login';
}
export function noMenuRedirect() {
    window.location.href = 'login/2';
}

export function noParamRedirect() {
    window.location.href = 'login/3';
}

export function errorRedirect() {
    window.location.href = 'login/4';
}

export function errorSSORedirect() {
    window.location.href = 'login/5';
}

export function unauthorizedPage() {
    window.location.href = 'unauthorized';
}

export function helpPage() {
    window.open(IsEnglish() ? storage.getConfigOnlineHelpEnglishLink() : storage.getConfigOnlineHelpFrenchLink());
}